import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/soon.png'
import _imports_1 from '@/assets/images/logo_2.png'
import _imports_2 from '@/assets/images/google_play.png'
import _imports_3 from '@/assets/images/app_store.png'
import _imports_4 from '@/assets/images/web_aplikacija.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-34c7c70a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loyalty-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "page page--loading"
}
const _hoisted_3 = {
  key: 1,
  class: "soon-page"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Uskoro",
  class: "soon-image"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 2,
  class: "page"
}
const _hoisted_7 = { class: "page-content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Soccerbet VIP Klub",
  class: "logo-main"
}, null, -1))
const _hoisted_9 = { class: "store-buttons" }
const _hoisted_10 = {
  key: 0,
  href: "https://play.google.com/store/apps/details?id=com.sagastartech.etitoapp.soccerbet.rs.prod&pcampaignid=web_share",
  target: "_blank",
  rel: "noreferrer",
  class: "store-button"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "Google Play",
  class: "store-button-image"
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  href: "https://apps.apple.com/us/app/soccerbet-rs-vip-club/id6752946557",
  target: "_blank",
  rel: "noreferrer",
  class: "store-button"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "App Store",
  class: "store-button-image"
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"divider-row\" data-v-34c7c70a><span class=\"divider-line\" data-v-34c7c70a></span><span class=\"divider-text\" data-v-34c7c70a>ili</span><span class=\"divider-line\" data-v-34c7c70a></span></div><div class=\"web-app-wrapper\" data-v-34c7c70a><a href=\"https://retail.soccerbet.rs/auth-successful?action=password-changed\" class=\"store-button\" data-v-34c7c70a><img src=\"" + _imports_4 + "\" alt=\"Web aplikacija\" class=\"store-button-image\" data-v-34c7c70a></a></div>", 2)
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<a href=\"javascript:void(0)\" class=\"help-link\" style=\"pointer-events:none;opacity:0.5;\" data-v-34c7c70a><span class=\"help-icon\" aria-hidden=\"true\" data-v-34c7c70a><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" data-v-34c7c70a><path d=\"M10 14H4C3.46667 14 2.93333 13.8 2.6 13.4C2.2 13.0667 2 12.5333 2 12V6C2 5.46667 2.2 4.93333 2.6 4.6C2.93333 4.2 3.46667 4 4 4H7.33333C7.73333 4 8 4.26667 8 4.66667C8 5.06667 7.73333 5.33333 7.33333 5.33333H4C3.8 5.33333 3.66667 5.4 3.53333 5.53333C3.4 5.66667 3.33333 5.8 3.33333 6V12C3.33333 12.2 3.4 12.3333 3.53333 12.4667C3.66667 12.6 3.8 12.6667 4 12.6667H10C10.2 12.6667 10.3333 12.6 10.4667 12.4667C10.6 12.3333 10.6667 12.2 10.6667 12V8.66667C10.6667 8.26667 10.9333 8 11.3333 8C11.7333 8 12 8.26667 12 8.66667V12C12 12.5333 11.8 13.0667 11.4 13.4C11 13.7333 10.5333 14 10 14Z\" fill=\"white\" data-v-34c7c70a></path><path d=\"M6.66667 10C6.46667 10 6.33333 9.93333 6.2 9.8C5.93333 9.53333 5.93333 9.13333 6.2 8.86667L12.8667 2.2C13.1333 1.93333 13.5333 1.93333 13.8 2.2C14.0667 2.46667 14.0667 2.86667 13.8 3.13333L7.13333 9.8C7 9.93333 6.86667 10 6.66667 10Z\" fill=\"white\" data-v-34c7c70a></path><path d=\"M13.3334 6.66667C12.9334 6.66667 12.6667 6.4 12.6667 6V3.33333H10C9.60004 3.33333 9.33337 3.06667 9.33337 2.66667C9.33337 2.26667 9.60004 2 10 2H13.3334C13.7334 2 14 2.26667 14 2.66667V6C14 6.4 13.7334 6.66667 13.3334 6.66667Z\" fill=\"white\" data-v-34c7c70a></path></svg></span><span class=\"help-text\" data-v-34c7c70a>Uputstvo za korisnike</span></a>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.status === 'loading')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : (_ctx.status === 'soon')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                (_ctx.platform === 'android' || _ctx.platform === null)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_10, _hoisted_12))
                  : _createCommentVNode("", true),
                (_ctx.platform === 'ios' || _ctx.platform === null)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_13, _hoisted_15))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_16
            ]),
            _hoisted_18
          ]))
  ]))
}